import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-category-boats.svg"

const IconCategoryBoats = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryBoats.displayName = "IconCategoryBoats"
export default IconCategoryBoats
